module.exports = __webpack_public_path__ + "static/media/PICT0060.3eaef3d5.jpg";